module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [(_vm.$slots.link) ? _c('div', {
    staticClass: "line__item",
    class: {
      line__item_half: _vm.$slots.link && _vm.$slots.cert
    }
  }, [_vm._t("link")], 2) : _vm._e(), (_vm.$slots.cert) ? _c('div', {
    staticClass: "line__item",
    class: [{
      line__item_half: _vm.$slots.link && _vm.$slots.cert
    }, {
      line__item_right: _vm.$slots.link
    }]
  }, [_vm._t("cert")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d203e75","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/header/Line.vue
// module id = 75ac27d3523c5438256c
// module chunks = 7